import { mapCrewbossTranslations } from "@sinch/utils/translations";
import React from "react";
import ReactDOM from "react-dom/client";
import { dictionary } from "../locale";
import { App } from "./App";
// WARNING! Do not change these imports, for some reason storybook stop working when short imports are used
import { initIntl } from "./config/i18n";

import { initErrorMonitor } from "./config/sentry";

import "./config/customValidationRules";

// Top level services initialisation
initErrorMonitor();
initIntl(dictionary);

/**
 * React entrypoint TODO: set by env
 */

/**
 * Initialisation method of application
 */
function init() {
  const domContainer = document.querySelector<HTMLElement>("#sinch-react-runtime");
  if (domContainer) {
    const root = ReactDOM.createRoot(domContainer);
    const settings = domContainer.dataset?.settings;
    const settingsObject = settings ? JSON.parse(settings) : null;
    settingsObject.crewbossName = mapCrewbossTranslations(settingsObject.crewbossName);

    initIntl(dictionary, settingsObject?.language ?? "en");

    root.render(<App {...settingsObject} />);
  } else {
    waitForElement("sinch-react-runtime", () => {
      init();
    });
  }
}

init();

function waitForElement(elementId: string, callback: () => void) {
  // Check if element already exists
  const element = document.getElementById(elementId);
  if (element) {
    callback();
    return;
  }

  // Create observer to watch for element
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.getElementById(elementId);
    if (element) {
      obs.disconnect(); // Stop observing
      callback();
    }
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
